/* eslint-disable @next/next/no-img-element */
import React, { useMemo } from 'react';
import { useApplicationState } from '../../../../hooks/common/use-application-state';
import  ReactMarkdownCustom  from './ReactMarkdownCustom';
import { useRef } from 'react';

type ReactMarkdownProps = {
  markdown: string;
  slug: string;
  showCopyButton?: boolean;
  components?: Object;
  className?: string;
  markdownClassName?: string;
  widgetComp?: Function;
  headingCount?: Number;
  runBtnClass?: string;
  runBtnFunction?: Function;
};

const ReactMarkdown = ({
  slug, markdown = '', markdownClassName, widgetComp, headingCount, runBtnClass, runBtnFunction
}: ReactMarkdownProps) => {
  const draftMode = useApplicationState((state) => state.noteDetails.draftMode);
  let {
    positions: commentsPosition,
  } = useApplicationState((state) => ({ 
    positions: draftMode ? [] : state.commentsData.positions,
  }));

  // Need to wrap compnoent for Markdown in ref since it uses memo so do not want to rerender everytime
  const imgObjRef = useRef({
    // eslint-disable-next-line react/no-unused-prop-types
    img: ({ node }: { node: any }) => {
      if (node.tagName === 'img') {
        return (
          <div style={{ minHeight: '200px' }}>
            <img
              src={`${node.properties?.src}`}
              alt={`${node.properties?.alt}`}
              width="100%"
              loading="lazy"
              className='scrollable-line'
            />
          </div>
        );
      }
      return null;
    },
  });

  return (
    <>
      <ReactMarkdownCustom
        slug={slug}
        markdown={markdown}
        markdownClassName={markdownClassName}
        components={imgObjRef.current}
        widgetComp={widgetComp}
        headingCount={headingCount}
        runBtnClass={runBtnClass}
        runBtnFunction={runBtnFunction}
        commentsPosition={commentsPosition}
      />
    </>
  );
};

export default ReactMarkdown;
